import { simpleGit, type SimpleGit } from 'simple-git';
import { isCliTrace } from '../cli-log-level.js';
import { logTrace } from '../log.js';
import { abortActiveGitChildProcesses } from './git-runtime.js';
import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';

/**
 * `simple-git` instance with stdout/stderr drained so non-repo `git` errors do not hit the TTY.
 * With `--trace`, subprocess output is copied to {@link logTrace}.
 * Git subprocesses are tracked via the spawn hook in {@link git-runtime} for fast interrupt handling.
 */
export function cliSimpleGit(baseDir: string): SimpleGit {
  const git = simpleGit({
    baseDir,
    trimmed: true,
    spawnOptions: {},
  });
  git.outputHandler((command, stdout, stderr) => {
    const trace = isCliTrace();
    const onChunk = (label: 'stdout' | 'stderr') => (chunk: Buffer | string) => {
      if (isCliImmediateShutdownRequested()) {
        abortActiveGitChildProcesses();
      }
      const text = typeof chunk === 'string' ? chunk : chunk.toString('utf8');
      const line = text.replace(/\s+$/, '');
      if (trace && line) {
        logTrace(`[git ${command}] ${label}: ${line}`);
      }
    };
    stdout?.on('data', onChunk('stdout'));
    stderr?.on('data', onChunk('stderr'));
  });
  return git;
}
